<div>
  <!-- Buttons -->
  <div style="margin-left: 80%; margin-bottom: 2%;" class="noPrint">
    <button [useExistingCss]="true"
            style="margin-right: 2%; margin-left: 2%; z-index: 10; font-size: 12px; font-weight: 600;"
            mat-raised-button color="primary" printSectionId="print-section" ngxPrint>
      Print
    </button>
    <button mat-dialog-close class="btn" style="z-index: 10">Close</button>
  </div>

  <!-- Wrapper -->
  <div class="wrapper" id="print-section">
   <script type="text/javascript">
        window.onload = addPageNumbers;

        function addPageNumbers() {
            var totalPages = Math.ceil(document.body.scrollHeight / 1123);  //842px A4 pageheight for 72dpi, 1123px A4 pageheight for 96dpi, 
            for (var i = 1; i <= totalPages; i++) {
                var pageNumberDiv = document.createElement("div");
                var pageNumber = document.createTextNode(" पृष्ठ क्र. " + i + " of " + totalPages);
                pageNumberDiv.style.position = "absolute";
                pageNumberDiv.style.marginTop = "calc((" + i + " * (297mm - 0.5px)) - 40px)"; //297mm A4 pageheight; 0,5px unknown needed necessary correction value; additional wanted 40px margin from bottom(own element height included)
                pageNumberDiv.style.height = "16px";
                pageNumberDiv.appendChild(pageNumber);
                document.body.insertBefore(pageNumberDiv, document.getElementById("content"));
                pageNumberDiv.style.left = "calc(100% - (" + pageNumberDiv.offsetWidth + "px + 20px))";
            }
        }
    </script>
    <!-- Fixed Header -->
    <div class="header">
      <span>{{ today | date:'dd/MM/yyyy hh:mm:ss' }} वर्गणी - वर्गणी जमा असलेले</span>
      <span *ngIf="deliveryMode != ''" style="margin-left: 1%;">वितरण - {{ deliveryMode }}</span>
      <span *ngIf="repNames != ''" style="margin-left: 1%; display: flex; flex-direction: column;">
        <span>प्रतिनिधी पासून - {{ firstRepName }}</span>
        <span>प्रतिनिधी पर्यंत - {{ lastRepName }}</span>
      </span>
      <span *ngIf="district != ''" style="margin-left: 1%;">जिल्हा - {{ district.join(', ') }}</span>
      <span *ngIf="taluka != ''" style="margin-left: 1%;">तालुका - {{ taluka.join(' , ') }}</span>
    </div>

    
    <!-- Content Grid -->
    <div class="print-grid">
      <ng-container *ngFor="let item of data1; let i = index">
        <div class="grid-item">
          <span style="font-size: 15px; font-weight: bold;" *ngIf="iscustomer=='yes'">
            {{ item['short_name'] }}{{ item['month']}}/{{ item['subno']}}-{{ item['year'] }}
          </span><br />

          <span *ngIf="item.address?.length > 84" style="font-size: 13px; font-weight: bold;">
            {{ item["title"] }} {{ item["name"] }}
          </span>
          <span *ngIf="item.address?.length <= 84" style="font-size: 15px; font-weight: bold;">
            {{ item["title"] }} {{ item["name"] }}
          </span><br />

          <span style="font-weight: bold; display: block;"
                [style.font-size.px]="item.address?.length > 94 ? 13 : 15">
            {{ item["address"] }}
          </span>
          <span *ngIf="item.taluka" style="font-weight: bold; display: block;"
                [style.font-size.px]="item.address?.length > 94 ? 13 : 15">
            {{ item["taluka"] }}
          </span>
          <span *ngIf="item['pincode'] != 0" style="font-weight: bold;"
                [style.font-size.px]="item.address?.length > 94 ? 13 : 15">
            <span *ngIf="item.district">{{ item["district"] }} - </span>
            {{ item["pincode"] }} {{ item["state"] }}
          </span>
        </div>
      </ng-container>
    </div>
 <!-- <ng-container *ngFor="let page of paginatedData(); let pageIndex = index">
       
      <div class="print-row-1">
        <span class="right-header-1">पृष्ठ क्र. {{ pageIndex + 1 }}</span>
      </div>

     
      <div class="page-break" *ngIf="pageIndex < paginatedData().length - 1"></div>

  </ng-container> -->
  </div>
</div>